module.exports = __webpack_public_path__ + "static/media/um.8754eddf.svg";